import { c as _c } from "react/compiler-runtime";
import React from "react";
interface TimeUnitDisplayProps {
  readonly value: number;
  readonly label: string;
}

/**
 * Displays a single time unit box for the countdown
 */
export const TimeUnitDisplay: React.FC<TimeUnitDisplayProps> = t0 => {
  const $ = _c(7);
  const {
    value,
    label
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <span className="tw-text-xs tw-font-medium tw-tabular-nums tw-text-iron-300">{value}</span>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="tw-text-xs tw-font-normal tw-text-iron-400">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-flex tw-items-center tw-gap-x-0.5">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};